import { setHours, setMinutes } from "date-fns"
import timestampFormatter from "../utils/timestampFormatter"

export function timeDisplay(time: string): string {
  const timeElements = time.split(":").map((time) => Number.parseInt(time))
  const dateWithTime = setMinutes(setHours(new Date(), timeElements[0] ?? 0), timeElements[1] ?? 0)
  return timestampFormatter(dateWithTime).displayTime
}

export function dateDisplay(valueDate: string): string {
  const date = new Date(valueDate)

  return timestampFormatter(date).displayDate
}

export function dateTimeDisplay(valueDateTime: string): string {
  const date = new Date(valueDateTime)

  const formattedDate = timestampFormatter(date)
  return `${formattedDate.displayTime} ${formattedDate.displayDate}`
}
